module.exports = __webpack_public_path__ + "img/userinf_jldt.bfc3d8ec.png";